import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import lodashNoop from 'lodash/noop';
import Button from '@adsk/bim360-matrix-react-button';
import Dropdown from '@adsk/bim360-matrix-react-dropdown';
import DropdownMenu from '@adsk/bim360-matrix-react-dropdown-menu';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import i18n from '../../utils/i18n';

class ProjectViewExport extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExportButtonOpen: false
    };
  }

  render() {
    const {disabled, disabledReason, exportOptions, isFetchReportLoading, exportingText} = this.props;
    const isSingleExportButton = exportOptions.length === 1;

    const iconClassName = cx('ProjectViewExport__export-button-icon', {
      'ProjectViewExport__export-button-icon--open': this.state.isExportButtonOpen
    });

    const exportButtonClassName = cx('ProjectViewExport__export-button', {
      'ProjectViewExport__export-button--disabled': disabled,
      'ProjectViewExport__export-button--dropdown': !isSingleExportButton
    });

    return (
      <div>
        <Tooltip
          theme={Tooltip.Themes.DARK}
          trigger={Tooltip.HOVER}
          place={Tooltip.Places.TOP}
          content={disabled && disabledReason ? disabledReason : ''}
        >
          {isSingleExportButton ? (
            <Button
              onClick={exportOptions[0].handleOnClick}
              disabled={disabled}
              className={exportButtonClassName}
              data-testid="ProjectViewExport__exportButton"
            >
              <span className="ProjectViewExport__export-text">
                {isFetchReportLoading ? exportingText : exportOptions[0].label}
              </span>
            </Button>
          ) : (
            <Dropdown
              disabled={disabled}
              onToggleMenu={() => this.setState({isExportButtonOpen: !this.state.isExportButtonOpen})}
              onSelect={lodashNoop}
              className="ProjectViewExport__export-dropdown"
            >
              <Button
                disabled={disabled}
                className={exportButtonClassName}
                data-testid="ProjectViewExport__exportButton"
              >
                <span className="ProjectViewExport__export-text">
                  {isFetchReportLoading ? exportingText : i18n.t('export.export')}
                </span>
                <span className={iconClassName} />
              </Button>
              <DropdownMenu className="ProjectViewExport__export-dropdown-list">
                {exportOptions.map((option, index) => (
                  <li key={index}>
                    <div
                      className="ProjectViewExport__export-item"
                      data-testid="ProjectViewExport__exportListItem"
                      onClick={option.handleOnClick}
                    >
                      {option.label}
                      {!!option.icon && option.icon}
                    </div>
                  </li>
                ))}
              </DropdownMenu>
            </Dropdown>
          )}
        </Tooltip>
      </div>
    );
  }
}

ProjectViewExport.displayName = 'ProjectViewExport';

ProjectViewExport.propTypes = {
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  isFetchReportLoading: PropTypes.bool,
  exportingText: PropTypes.string,
  exportOptions: PropTypes.array.isRequired
};

export default ProjectViewExport;
